import * as React from "react";
import * as ReactDOM from "react-dom";


export interface IInputContainerProperties
{
    children?: any,
    style?: React.CSSProperties,
    alignLeft?: boolean
}

export class InputContainer extends React.Component<IInputContainerProperties>
{
    render()
    {
        var className: string[] = ["input-container"];

        if (this.props.alignLeft)
            className.push("input-container--alignleft");

        return (
            <div
                className={className.join(" ")}
                style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}